<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">手机充值</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 顶部tab 开始 -->
    <div class="page_tab phonetoptab">
      <div class="page_tablist" v-for="(item,index) in phonetopHead" @click="changephonehead(index)">
        <div :class="item.topselect? 'page_tabname' : 'page_tabname1'">{{item.name}}</div>
      </div>
      <img class="zhekoutipicon" src="/static/jiuwutipicon.png" />
    </div>
    <!-- 顶部tab 结束 -->
    <!-- 手机慢充值 开始 -->
    <div v-if="phonetopheadindex==1">
      <!-- 输入手机 开始 -->
      <!-- <div class="page_top">
        <div class="page_pname">手机号码</div>
        <div class="page_pnum">
          <input class="page_pnuminputphone" placeholder="请输入手机号" type="tel" v-model="chargeNum" />
          <img class="page_pimg" src="/static/newicon/chongzhiphone.png" />
        </div>
      </div> -->
      <div class="page_top" style="height: auto;">
        <div class="page_pname">手机号码</div>
        <div class="page_pnum">
          <input class="page_pnuminputphone" @input="phoneNumSlow()" placeholder="请输入手机号" type="tel" v-model="chargeNumSlow"
            value="phoneSlow" />
          <img class="page_pimg" src="/static/newicon/chongzhiphone.png" />
        </div>
        <div class="page_pnum" v-if="phoneSlow!=chargeNumSlow">
          <input class="page_pnuminputphone1" type="number" placeholder="请输入验证码" v-model="phoneCodeSlow" />
          <div class="phone_yanzheng" @click='getPhoneCodeSlow()'>{{ currentTimeSlow ? currentTimeSlow : "获取验证码" }}</div>
        </div>
      </div>

      <!-- 输入手机 结束 -->
      <div :class="phoneSlow!=chargeNumSlow ? 'taocanbox1' : 'taocanbox'">
        <!-- 套餐选择 开始 -->
        <div class="page_taocan" style="top: 0;">
          <div class="page_taocan_name">请选择充值金额</div>
          <div class="page_taocan_list">
            <div :class="item.checked? 'page_taocan_box1' :'page_taocan_box' " class="phone_tocan_box" v-for="(item,index) in  list.slowCharge"
              @click="changephonenumSlow(index)">
              <div class="page_taocan_num phone_num">{{item.name}}</div>
              <img v-if="item.checked" class="page_taocan_checkimg" src="/static/newprojecticon/chongzhicheck.png" />
            </div>
          </div>
        </div>
        <!-- 套餐选择 结束 -->
        <div v-if="slowcharge" :class="phone!=chargeNum ? 'phonetype_taocan1' : 'phonetype_taocan'">
          <div class="pagepaytype_text">选择支付方式</div>
          <div class="page_shangpin_box" @click="weixinPay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/weixinpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">微信支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_shoujia">{{ priceSlow ? priceSlow+'元' : '' }}</div>
              <img :src="isWeixinPay? '/static/checkdeicon.png' : '/static/checkicon.png'" class="page_checklogo" />
            </div>
          </div>
          <div class="page_shangpin_box" @click="yuePay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/jifenpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">积分支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_keyong">可用积分</div>
              <div class="page_shangpin_shoujia">{{amount}}</div>
              <img :src="isWeixinPay? '/static/checkicon.png' : '/static/checkdeicon.png'" class="page_checklogo" />
            </div>
          </div>
        </div>
        <!-- 支付 开始 -->
        <div class="page_button" :class="phoneSlow!=chargeNumSlow ? 'phone_button1' : 'phone_button'" @click="toRechargeSlow()">
          <div class="page_zhifu">立即支付（{{priceSlow}}积分）</div>
        </div>
        <!-- 支付 结束 -->
        <!-- 注意事项 开始 -->
        <div class="page_mesg">
          <div class="page_mesgtitle">
            <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
            <div class="page_mesgtext">注意事项</div>
          </div>
          <div class="page_mesgtip" style="color: #029dff">支付成功后，72小时内到账</div>
          <div class="page_mesgtip">携号转网号码无法充值</div>
          <div class="page_mesgtip" style="color: #029dff">请核对录入的手机号是否正确，如果录入错误无法返回，造成的损失由个人承担</div>
          <div class="page_mesgtip">周末顺延到工作日处理</div>

          <!-- <div class="page_mesgtip">2：充值成功后，搜索“<span class="page_mesgtipspan">大家来加油</span>”小程序，授权微信并使用充值的手机号码登录，点击“电子加油券”设置支付密码后，即可到加油站打开二维码支付使用。
          </div> -->
        </div>
        <!-- 注意事项 结束 -->
      </div>

    </div>
    <!-- 手机慢充值 结束 -->
    <!-- 手机快充值 开始 -->
    <div v-if="phonetopheadindex==0">
      <!-- 输入手机 开始 -->
      <div class="page_top" style="height: auto;">
        <div class="page_pname">手机号码</div>
        <div class="page_pnum">
          <input class="page_pnuminputphone" @input="phoneNum()" placeholder="请输入手机号" type="tel" v-model="chargeNum"
            value="phone" />
          <img class="page_pimg" src="/static/newicon/chongzhiphone.png" />
        </div>
        <div class="page_pnum" v-if="phone!=chargeNum">
          <input class="page_pnuminputphone1" type="number" placeholder="请输入验证码" v-model="phoneCode" />
          <div class="phone_yanzheng" @click='getPhoneCode()'>{{ currentTime ? currentTime : "获取验证码" }}</div>
        </div>
      </div>

      <!-- 输入手机 结束 -->
      <div :class="phone!=chargeNum ? 'taocanbox1' : 'taocanbox'">
        <!-- 套餐选择 开始 -->
        <!--  :class="phone!=chargeNum ? 'phone_taocan1' : 'phone_taocan'" -->
        <div class="page_taocan" style="top: 0;">
          <div class="page_taocan_name">请选择充值金额</div>
          <div class="page_taocan_list">
            <div :class="item.checked? 'page_taocan_box1' :'page_taocan_box' " class="phone_tocan_box" v-for="(item,index) in  list.phoneBills"
              @click="changephonenum(index)">
              <div class="page_taocan_num phone_num">{{item.name}}</div>
              <img v-if="item.checked" class="page_taocan_checkimg" src="/static/newprojecticon/chongzhicheck.png" />
            </div>
          </div>
        </div>
        <!-- 套餐选择 结束 -->
        <div v-if="slowcharge" :class="phone!=chargeNum ? 'phonetype_taocan1' : 'phonetype_taocan'">
          <div class="pagepaytype_text">选择支付方式</div>
          <div class="page_shangpin_box" @click="weixinPay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/weixinpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">微信支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_shoujia">{{ price ? price+'元' : '' }}</div>
              <img :src="isWeixinPay? '/static/checkdeicon.png' : '/static/checkicon.png'" class="page_checklogo" />
            </div>
          </div>
          <div class="page_shangpin_box" @click="yuePay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/jifenpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">积分支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_keyong">可用积分</div>
              <div class="page_shangpin_shoujia">{{amount}}</div>
              <img :src="isWeixinPay? '/static/checkicon.png' : '/static/checkdeicon.png'" class="page_checklogo" />
            </div>
          </div>
        </div>
        <!-- 支付 开始 -->
        <div class="page_button" :class="phone!=chargeNum ? 'phone_button1' : 'phone_button'" @click="toRecharge()">
          <div class="page_zhifu">立即支付（{{price}}积分）</div>
        </div>
        <!-- 支付 结束 -->
        <!-- 注意事项 开始 -->
        <div class="page_mesg">
          <div class="page_mesgtitle">
            <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
            <div class="page_mesgtext">注意事项</div>
          </div>
          <div class="page_mesgtip">携号转网号码无法充值</div>
          <div class="page_mesgtip" style="color: #FD8C00">请核对录入的手机号是否正确，如果录入错误无法返回，造成的损失由个人承担</div>
          <!-- <div class="page_mesgtip">支付成功后，72小时内到账</div> -->
          <!-- <div class="page_mesgtip">2：充值成功后，搜索“<span class="page_mesgtipspan">大家来加油</span>”小程序，授权微信并使用充值的手机号码登录，点击“电子加油券”设置支付密码后，即可到加油站打开二维码支付使用。
          </div> -->
        </div>
        <!-- 注意事项 结束 -->
      </div>
      <!--
    <div v-if="phonetopheadindex==1">
      <div class="page_top">
        <div class="page_pname">手机号码</div>
        <div class="page_pnum">
          <input class="page_pnuminput" placeholder="请输入手机号" type="tel" v-model="chargeNum" />
          <img class="page_pimg" src="/static/newicon/chongzhiphone.png" />
        </div>
      </div>
      <div class="page_taocan phone_taocan">
        <div class="page_taocan_name">请选择充值金额</div>
        <div class="page_taocan_list">
          <div :class="item.checked? 'page_taocan_box1' :'page_taocan_box' " v-for="(item,index) in  list.data" @click="changedata(index)">
            <div class="page_taocan_num">{{item.name}}</div>
            <img v-if="item.checked" class="page_taocan_checkimg" src="/static/newicon/checked.png" />
          </div>
        </div>
      </div>
    </div> -->
    </div>
    <!-- 手机快充值 结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http'
  import httpers from '../../api/https'
  import {
    Dialog
  } from 'vant';
  var phone_mreg = /^1[2-9][0-9]{9}$/;
  export default {
    data() {
      return {
        userinfo: {},
        phonetopHead: [{
            name: "快充",
            topselect: true,
          },
          {
            name: "慢充",
            topselect: false,
          }
        ],
        phonetopheadindex: 0,
        // isData: 'slowCharge', // 用户点击选中慢充话费，否则快充话费
        isData: 'phoneBills', //用户点击选中慢充话费，否则快充话费
        price: "", //套餐价格
        priceSlow: "", //慢充套餐价格
        amount: 0, // 接口获取用户可用余额,默认为0
        chargeNum: '', // 所快充值的手机号码
        chargeNumSlow: '', // 所慢充值的手机号码
        buttonClicked: false, // 防止支付重复点击,默认为false
        list: {}, // 接口获取列表
        phone: "", //默认手机号
        phoneSlow: "", //慢充默认手机号
        phoneCode: '', // 验证码,默认为空
        phoneCodeSlow: '', // 慢充验证码,默认为空
        currentCode: '', // 接口获取正确的验证码,默认为空
        currentCodeSlow: '', // 接口获取慢充正确的验证码,默认为空
        currentTime: '', // 验证码倒计时,默认为空
        currentTimeSlow: '', //慢充 验证码倒计时,默认为空
        phoneCodeStatus: false, // 验证码状态,默认为false
        phoneCodeStatusSlow: false, // 慢充验证码状态,默认为false
        isWeixinPay: false,
        slowcharge: false, //慢充
        product: [], //充值
      }
    },
    created() {
      let that = this
      setTimeout(function() {
        that.request('getProductList', {
          tab_id: 2
        })
      }, 400)
      that.request('getUserInfo')
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //改变顶部导航
      changephonehead(e) {
        let that = this
        let phonetopHead = that.phonetopHead
        phonetopHead.map((item, index) => item.topselect = index === Number(e))
        that.phonetopheadindex = Number(e)
        if (e == 1) {
          if (that.slowcharge) {
            that.isData = 'slowCharge'
            var product = that.product
            var list = {}
            list.slowCharge = product[1].productItem
            for (let i in list.slowCharge)
              list.slowCharge[i].checked = false
            list.slowCharge[0].checked = true
            let price = parseFloat(list.slowCharge[0].price).toFixed(2)
            let wxPrice = parseFloat(list.slowCharge[0].price).toFixed(2)
            let canAmountPay = (that.amount - price) >= 0
            console.log("数据慢充", list)
            that.list = list
            that.priceSlow = price
          } else {
            Dialog.alert({
              title: '提示',
              message: '慢充功能维护中，敬请期待',
            }).then(() => {
              this.phonetopheadindex = 0
              this.isData = 'phoneBills'
              phonetopHead[0].topselect = true
              phonetopHead[1].topselect = false
            });
          }

        } else {
          // if (that.slowcharge) {
          //   Dialog.alert({
          //     title: '提示',
          //     message: '快充功能维护中，敬请期待',
          //   }).then(() => {
          //     that.phonetopheadindex = 1
          //     that.isData = 'slowCharge'
          //     phonetopHead[1].topselect = true
          //     phonetopHead[0].topselect = false
          //   });
          // } else {
          that.isData = 'phoneBills'
          var product = that.product
          var list = {}
          list.phoneBills = product[0].productItem
          for (let i in list.phoneBills)
            list.phoneBills[i].checked = false
          list.phoneBills[0].checked = true
          let price = parseFloat(list.phoneBills[0].price).toFixed(2)
          let wxPrice = parseFloat(list.phoneBills[0].price).toFixed(2)
          let canAmountPay = (that.amount - price) >= 0
          console.log("数据快充", list)
          that.list = list
          that.price = price
          //}

        }
      },
      //改变手机号码套餐
      changephonenum(e) {
        let that = this
        this.list.phoneBills.map((item, index) => item.checked = index === Number(e))
        that.price = parseFloat(this.list.phoneBills[Number(e)].price).toFixed(2)
      },
      //改变慢充手机号码套餐
      changephonenumSlow(e) {
        let that = this
        this.list.slowCharge.map((item, index) => item.checked = index === Number(e))
        that.priceSlow = parseFloat(this.list.slowCharge[Number(e)].price).toFixed(2)
      },
      //选择流量的价格
      // changedata(e) {
      //   this.list.data.map((item, index) => item.checked = index === Number(e))
      //   this.price = parseFloat(this.list.phoneBills[Number(e)].price).toFixed(2)
      // },
      //改变话费还是流量
      changephonebill() {
        this.isData = 'phoneBills'
      },
      //流量
      changeliuliang() {
        this.isData = 'data'
        this.$toast({
          message: "流量充值功能维护中，敬请期待",
        })
        this.isData = 'phoneBills'
      },
      //微信支付
      weixinPay() {
        this.isWeixinPay = true
      },
      //余额支付
      yuePay() {
        this.isWeixinPay = false
      },
      //快充支付
      toRecharge() {
        var order_param = {} //下单参数
        var that = this
        this.buttonClickedFun(1000) // 防止重复点击
        //快充话费
        for (let i in this.list.phoneBills) {
          if (this.list.phoneBills[i].checked) {
            var product_item = this.list.phoneBills[i]
          }
        }

        order_param.amount = product_item.price
        order_param.recharge_number = that.chargeNum
        order_param.type = 'online'
        order_param.product_type = 3
        order_param.product_item_id = product_item.id

        if (!phone_mreg.test(order_param.recharge_number)) {
          this.$toast({
            message: '手机号格式错误'
          })
          return
        }

        if (that.phone != that.chargeNum) {
          if (!that.phoneCode || that.phoneCode != that.currentCode) {
            this.$toast({
              message: '请输入正确的验证码'
            })
            return
          }
        }

        // 判断用户是微信支付还是余额支付
        if (this.isWeixinPay) {
          Dialog.confirm({
              title: '提示',
              message: '是否使用微信支付?',
            })
            .then(() => {
              // order_param.pay_type = 'balance'
              // that.request('YeunifiedOrder', order_param)
              order_param.pay_type = 'wechatpay'
              that.request('WxunifiedOrder', order_param)
            })
            .catch(() => {
              return false;
            });
        } else {
          //快充
          if (parseFloat(this.price) > parseFloat(this.amount)) {
            Dialog.confirm({
                title: '提示',
                message: '积分不足，前往充值？',
              })
              .then(() => {
                that.$router.push({
                  path: "/account"
                })
              })
              .catch(() => {
                return false;
              });
          } else {
            Dialog.confirm({
                title: '提示',
                message: '请认真核对手机号码\n' + that.chargeNum + '\n充错无法返回',
              })
              .then(() => {
                order_param.pay_type = 'balance'
                console.log("order_param快", order_param)
                that.request('YeunifiedOrder', order_param)
              })
              .catch(() => {
                return false;
              });
          }
        }

        // Dialog.confirm({
        //     title: '提示',
        //     message: '是否用余额支付?',
        //   })
        //   .then(() => {
        //     order_param.pay_type = 'balance'
        //     that.request('YeunifiedOrder', order_param)
        //   })
        //   .catch(() => {
        //     return false;
        //   });

      },
      //慢充支付
      toRechargeSlow() {
        var order_param = {} //下单参数
        var that = this
        this.buttonClickedFun(1000) // 防止重复点击
        //慢充
        for (let i in this.list.slowCharge) {
          if (this.list.slowCharge[i].checked) {
            var product_item = this.list.slowCharge[i]
          }
        }
        order_param.amount = product_item.price
        order_param.recharge_number = that.chargeNumSlow
        order_param.type = 'online'
        order_param.product_type = 3
        order_param.product_item_id = product_item.id

        if (!phone_mreg.test(order_param.recharge_number)) {
          this.$toast({
            message: '手机号格式错误'
          })
          return
        }

        if (that.phoneSlow != that.chargeNumSlow) {
          if (!that.phoneCodeSlow || that.phoneCodeSlow != that.currentCodeSlow) {
            this.$toast({
              message: '请输入正确的验证码'
            })
            return
          }
        }

        // 判断用户是微信支付还是余额支付
        if (this.isWeixinPay) {
          Dialog.confirm({
              title: '提示',
              message: '是否使用微信支付?',
            })
            .then(() => {
              // order_param.pay_type = 'balance'
              // that.request('YeunifiedOrder', order_param)
              order_param.pay_type = 'wechatpay'
              that.request('WxunifiedOrder', order_param)
            })
            .catch(() => {
              return false;
            });
        } else {
          //慢充
          if (parseFloat(this.priceSlow) > parseFloat(this.amount)) {
            Dialog.confirm({
                title: '提示',
                message: '积分不足，前往充值？',
              })
              .then(() => {
                that.$router.push({
                  path: "/account"
                })
              })
              .catch(() => {
                return false;
              });
          } else {
            Dialog.confirm({
                title: '提示',
                message: '请认真核对手机号码\n' + that.chargeNumSlow + '\n充错无法返回',
              })
              .then(() => {
                order_param.pay_type = 'balance'
                console.log("order_param慢", order_param)
                that.request('YeunifiedOrder', order_param)
              })
              .catch(() => {
                return false;
              });
          }
        }

        // Dialog.confirm({
        //     title: '提示',
        //     message: '是否用余额支付?',
        //   })
        //   .then(() => {
        //     order_param.pay_type = 'balance'
        //     that.request('YeunifiedOrder', order_param)
        //   })
        //   .catch(() => {
        //     return false;
        //   });

      },
      //输入手机号时触发
      phoneNum() {
        let that = this
        that.chargeNum = this.chargeNum
        that.phoneCodeStatus = phone_mreg.test(this.chargeNum)
      },
      //输入手机号时触发
      phoneNumSlow() {
        let that = this
        that.chargeNumSlow = this.chargeNumSlow
        that.phoneCodeStatusSlow = phone_mreg.test(this.chargeNumSlow)
      },
      //获取验证码
      getPhoneCode() {
        let that = this
        let requestData = {}
        // 获取验证码
        that.buttonClickedFun(1500)
        if (!that.phoneCodeStatus) {
          this.$toast({
            message: '请输入正确的手机号',
          })
          return
        }
        if (!that.chargeNum) {
          this.$toast({
            message: '请输入手机号',
          })
          return
        }
        if (that.phoneCodeStatus && that.chargeNum) {
          requestData.mobile = that.chargeNum
          this.request('sendCode', requestData)
        }
      },
      //获取验证码Slow
      getPhoneCodeSlow() {
        let that = this
        let requestData = {}
        // 获取验证码
        that.buttonClickedFun(1500)
        if (!that.phoneCodeStatusSlow) {
          this.$toast({
            message: '请输入正确的手机号',
          })
          return
        }
        if (!that.chargeNumSlow) {
          this.$toast({
            message: '请输入手机号',
          })
          return
        }
        if (that.phoneCodeStatusSlow && that.chargeNumSlow) {
          requestData.mobile = that.chargeNumSlow
          this.request('SlowsendCode', requestData)
        }
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //刚进入页面获取的数据
          case 'getProductList':
            httper.get('/product/get-online-by-api-tab', requestData, function(res) {
              if (res.code === 0) {
                //
                that.product = res.data
                // if (sessionStorage.getItem("source") == "sjcmdl" || sessionStorage.getItem("source") == "cxkjdl") {
                //   that.slowcharge = true
                // } else {
                //   that.slowcharge = false
                // }
                // if (that.userinfo.id == 167) {
                //   that.slowcharge = true
                // }
                // console.log()
                if (that.isData == 'slowCharge') {
                  var product = res.data
                  var list = {}
                  // list.phoneBills = product[0].productItem
                  list.slowCharge = product[1].productItem
                  for (let i in list.slowCharge)
                    list.slowCharge[i].checked = false
                  list.slowCharge[0].checked = true
                  let price = parseFloat(list.slowCharge[0].price).toFixed(2)
                  let wxPrice = parseFloat(list.slowCharge[0].price).toFixed(2)
                  let canAmountPay = (that.amount - price) >= 0
                  console.log("数据11慢充", list)
                  that.list = list
                  that.priceSlow = price
                } else {
                  var product = res.data
                  var list = {}
                  let bill = product[0].productItem

                  var j = bill.length;
                  while (j--) {
                    //console.log(j + ' = ' + bill[j]);
                    if (bill[j].show_status === 0) {
                      bill.splice(j, 1);
                    }
                  }
                  for (let i in bill) {
                    bill[i].checked = false
                    bill[0].checked = true
                    // console.log("bill[i].show_status", bill[i].show_status)
                    // if (bill[i].show_status == 0) {
                    //   bill.splice(i--, 1)
                    // }
                  }
                  //console.log("bill", bill);

                  // let obj = [{
                  //   id: 600,
                  //   name: "30元",
                  //   price: 30,
                  //   checked: false
                  // }, {
                  //   id: 601,
                  //   name: "50元",
                  //   price: 50,
                  //   checked: false
                  // }]
                  // for (let t in obj) {
                  //   bill.push(obj[t])
                  // }
                  // var userId = [42, 45, 46, 49, 50, 86, 167, 168]
                  // var availableUser = false
                  // for (var i = 0; i < userId.length; i++) {
                  //   if (userId[i] == that.userinfo.id) {
                  //     availableUser = true
                  //   }
                  // }
                  // if (!availableUser) {
                  //   for (let j in bill) {
                  //     if (bill[j].price == 30) {
                  //       bill.splice(j, 1)
                  //     }
                  //   }
                  //   for (let n in bill) {
                  //     if (bill[n].price == 50) {
                  //       bill.splice(n, 1)
                  //     }
                  //   }
                  // }
                  list.phoneBills = bill
                  console.log("list.phoneBills", list.phoneBills)
                  let price = parseFloat(list.phoneBills[0].price).toFixed(2)
                  let wxPrice = parseFloat(list.phoneBills[0].price).toFixed(2)
                  let canAmountPay = (that.amount - price) >= 0
                  console.log("数据11快充", list)
                  that.list = list
                  that.price = price
                }
                // var product = res.data
                // var list = {}
                // list.phoneBills = product[0].productItem
                // list.data = product[1].productItem
                // for (let i in list.phoneBills)
                //   list.phoneBills[i].checked = false
                // list.phoneBills[0].checked = true
                // let price = parseFloat(list.phoneBills[0].price).toFixed(2)
                // let wxPrice = parseFloat(list.phoneBills[0].price).toFixed(2)
                // let canAmountPay = (that.amount - price) >= 0
                // console.log("数据", list)
                // that.list = list
                // that.price = price
              } else {
                that.$toast({
                  message: res.data.message || '系统异常',
                })
              }
            }, true)
            break
            //获取个人信息余额
          case 'getUserInfo':
            httper.get('/wechat/user/info', requestData, res => {
              if (res.code === 0) {
                let amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
                that.userinfo = res.data
                that.phone = res.data.mobile
                that.phoneSlow = res.data.mobile
                that.chargeNum = that.phone
                that.chargeNumSlow = that.phoneSlow
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            // 发送短息验证码
          case 'sendCode':
            httpers.post('msg/send-code', requestData, res => {
              console.log('code：', res.data)
              if (res.code == 0) {
                that.currentCode = res.data
                this.$toast({
                  message: '验证码已发送',
                });
                // 倒计时
                let time = 91
                let interval = setInterval(() => {
                  time--
                  if (time > 10) {
                    that.currentTime = time + '秒'
                  }
                  if (time > 0 && time <= 10) {
                    that.currentTime = ' ' + time + '秒'
                  }
                  if (time <= 0) {
                    clearInterval(interval)
                    that.currentTime = ''
                  }
                }, 1000)
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            })
            break
            // 慢充发送短息验证码
          case 'SlowsendCode':
            httpers.post('msg/send-code', requestData, res => {
              console.log('code：', res.data)
              if (res.code == 0) {
                that.currentCodeSlow = res.data
                this.$toast({
                  message: '验证码已发送',
                });
                // 倒计时
                let time = 91
                let interval = setInterval(() => {
                  time--
                  if (time > 10) {
                    that.currentTimeSlow = time + '秒'
                  }
                  if (time > 0 && time <= 10) {
                    that.currentTimeSlow = ' ' + time + '秒'
                  }
                  if (time <= 0) {
                    clearInterval(interval)
                    that.currentTimeSlow = ''
                  }
                }, 1000)
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            })
            break
            //余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              if (res.code === 0) {
                // wx.navigateTo({
                //   url: '/pages/order/detail?id=' + res.data.order_no
                // })
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
          case 'orderCancel':
            httper.post('/order/cancel', requestData, res => {
              console.log("取消", res)
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: '/orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style>
  .phone_taocan {
    height: 170px;
  }

  .taocanbox {
    position: absolute;
    top: 220px;
  }

  .taocanbox1 {
    position: absolute;
    top: 290px;
  }

  .phone_taocan1 {
    height: 170px;
    /*  top: -35px; */
  }

  .phone_num {
    font-size: 22px;
    font-weight: bold;
  }

  .phone_yanzheng {
    width: 30%;
    height: 31px;
    border: 1px solid #fff;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ::-webkit-input-placeholder {
    text-align: start;
    color: hsla(0, 0%, 100%, 1);
    font-size: 16px;
  }

  .phone_tocan_box {
    margin: 5px;

  }

  .phone_button {
    /* margin-top: 170px; */
    margin-top: 20px;
  }

  .page_pnuminputphone {
    background-color: transparent;
    border: none;
    color: #fff;
    font-size: 26px;
    font-weight: bold;
    /* width: calc(100% - 200px); */
    width: 70%;
  }

  .page_pnuminputphone1 {
    width: 70%;
    background-color: transparent;
    border: none;
    color: #fff;
    font-size: 26px;
    font-weight: bold;

  }

  .phone_button1 {
    /* margin: 190px 30px 0 30px; */
    margin: 30px 30px 0 30px;
  }

  .phonetype_taocan {
    width: calc(100% - 40px);
    margin: 20px !important;
    /* margin-top: -60px; */
    box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
    border-radius: 5px;
    padding: 20px 10px;
    box-sizing: border-box;
  }

  .phonetype_taocan1 {
    width: calc(100% - 40px);
    margin: 20px !important;
    /* margin-top: -20px; */
    box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
    border-radius: 5px;
    padding: 20px 10px;
    box-sizing: border-box;
  }

  .phonetoptab {
    position: relative;
  }

  .zhekoutip {
    width: 38px;
    height: 18px;
    background: #F41D4F;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    top: 5px;
    right: 20px;
  }

  .zhekoutipicon {
    width: 38px;
    height: 18px;
    position: absolute;
    top: 5px;
    /*   right: 42px; */
    right: 11%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/phone/phone.vue